export default "__VITE_ASSET__DAUCuIUz__"